<template>
  <thead>
    <tr v-if="superHeaders">
      <th
        v-for="key in superHeaderKeysIterator"
        class="k-table-header super-header"
        scope="col"
        :key="key"
        :colspan="getSuperHeaderColSpan(superHeaders[key])"
        :class="{'fixed-column': superHeaders[key].subHeaderKeys.some(subKey => fixedColumnKeys.includes(subKey))}"
      >
        {{superHeaders[key].name}}
      </th>
    </tr>
    <tr>
      <th
        v-for="key in columnOrder"
        class="k-table-header"
        scope="col"
        :class="[`k-table-header-${key}`, {'fixed-column': fixedColumnKeys.includes(key)}]"
        :key="key"
      >
        <div class="k-table-header-content">
          <template v-if="headers[key].hasMultiSelectDropdown || headers[key].hasDropdown">
            <k-table-filters
              :headers="{ [key]: headers[key] }"
              :shown-keys="[key]"
              :unique-dropdown-options="uniqueDropdownOptions"
              :dropdown-filters="dropdownFilters"
              :search-filters="searchFilters"
              :on-dropdown-filter-change="onDropdownFilterChange"
              :on-search-filter-change="onSearchFilterChange"
            />
          </template>
          <template v-else-if="headers[key].trim">
            <k-tooltip
              :text="getHeaderTooltip(headers[key])"
            >
              <div :class="getHeaderClasses(headers[key])">
                <span
                  class="k-table-header-text"
                  v-html="headers[key].displayName || headers[key].name"
                ></span>
              </div>
            </k-tooltip>
          </template>
          <template v-else>
            <span
              class="k-table-header-text"
              v-html="headers[key].displayName || headers[key].name"
            ></span>
          </template>
          <k-tooltip
            v-if="headers[key].options.tooltip"
            :text="headers[key].options.tooltipText"
            text-align="large-tooltip"
          >
            <i class="fas fa-question-circle header-tooltip-icon" aria-hidden="true"></i>
          </k-tooltip>
          <div class="k-table-header-button-block">
            <template v-if="headers[key].filterable">
              <k-table-filters
                :headers="{ [key]: headers[key] }"
                :shown-keys="[key]"
                :unique-dropdown-options="uniqueDropdownOptions"
                :dropdown-filters="dropdownFilters"
                :search-filters="searchFilters"
                :on-dropdown-filter-change="onDropdownFilterChange"
                :on-search-filter-change="onSearchFilterChange"
              />
            </template>
            <template v-if="headers[key].sortable">
              <span class="k-table-button">
                <button
                  class="btn btn-primary btn-sm"
                  :class="`k-table-sort-${key}`"
                  @click="onSort(key)"
                  :aria-label="`Sort by ${headers[key].name}`"
                  :title="`Sort by ${headers[key].name}`"
                >
                  <span class="fas fa-sort" aria-hidden="true"></span>
                </button>
              </span>
            </template>
          </div>
        </div>
      </th>
    </tr>
  </thead>
  </template>

<script>
import KTooltip from '../../k-tooltip.vue';
import KTableFilters from './k-table-filters.vue';

export default {
  components: {
    KTooltip,
    KTableFilters,
  },

  props: {
    headers: Object,
    columnOrder: Array,
    superHeaders: Object,
    uniqueDropdownOptions: Object,
    dropdownFilters: Object,
    searchFilters: Object,
    superHeaderKeysIterator: Array,
    getSuperHeaderColSpan: Function,
    onSort: Function,
    fixedColumnKeys: Array,
    onDropdownFilterChange: Function,
    onSearchFilterChange: Function,
  },

  methods: {
    getHeaderClasses(header) {
      return header?.options?.classes || '';
    },

    getHeaderTooltip(header) {
      const classes = this.getHeaderClasses(header);
      return classes ? `${header.name} - ${classes}` : header.name;
    },
  },
};
</script>
